import { CONTACT_POINT_SYSTEM } from "utils/constants";
import { applyAcorisRiaOlderThanOneYearTest } from "screens/Private/Broker/Projects/Detail/Templates/Comparison/Acoris/utils/riaBlock";
import { acorisTerminationDateSchema } from "screens/Private/Broker/Projects/Detail/Templates/Comparison/Acoris/utils/terminationRequest";
import {
  ACORIS_ZIP_CODE_PATTERN,
  validateAcorisZipCode,
} from "screens/Private/Broker/Projects/Detail/Templates/Comparison/Acoris/utils/zipCode";
import {
  acorisMinBirthDateEndOfYear,
  hundredYearsAgoStart,
} from "utils/helpers/date";
import * as yup from "yup";

const zipCodeSchema = (errors, fetchZipCodeCities) =>
  fetchZipCodeCities
    ? yup
        .string()
        .typeError(errors.REQUIRED)
        .required(errors.REQUIRED)
        .test("isValid", errors.INVALID_VALUE, function (value) {
          return validateAcorisZipCode(value, fetchZipCodeCities);
        })
    : yup
        .string()
        .typeError(errors.REQUIRED)
        .required(errors.REQUIRED)
        .matches(ACORIS_ZIP_CODE_PATTERN, {
          message: errors.INVALID_VALUE,
          excludeEmptyString: true,
        });

const validation = (errors, options = {}) => {
  const { fetchZipCodeCities } = options;
  return yup.object().shape({
    telecoms: yup.object().shape({
      [CONTACT_POINT_SYSTEM.ZIP_CODE]: yup.object().shape({
        value: zipCodeSchema(errors, fetchZipCodeCities),
      }),
    }),
    birthDate: yup
      .date()
      .typeError(errors.REQUIRED)
      .max(acorisMinBirthDateEndOfYear.toDate(), errors.ACORIS.ADHERENT_AGE)
      .min(hundredYearsAgoStart.toDate(), errors.ACORIS.ADHERENT_AGE)
      .required(errors.REQUIRED),
    socialRegime: yup
      .string()
      .typeError(errors.REQUIRED)
      .required(errors.REQUIRED),
    issuanceDate: yup
      .date()
      .typeError(errors.REQUIRED)
      .required(errors.REQUIRED),
    optMadelin: yup.boolean().nullable(),
    replaceContract: yup.boolean().nullable(),
    contractOlderThanOneYear: yup.boolean().when("replaceContract", {
      is: true,
      then: applyAcorisRiaOlderThanOneYearTest(
        yup.boolean().typeError(errors.REQUIRED).required(errors.REQUIRED),
        errors.ACORIS && errors.ACORIS.RIA_UNDER_ONE_YEAR,
      ),
      otherwise: yup.boolean().nullable(),
    }),
    terminationRequest: yup.mixed().when("contractOlderThanOneYear", {
      is: true,
      then: yup.object().shape({
        zipCode: zipCodeSchema(errors, fetchZipCodeCities),
        terminationDate: acorisTerminationDateSchema(errors),
      }),
      otherwise: yup.mixed().nullable(),
    }),
  });
};

export default validation;
